export const GOLD_CARD_FIELD = 'isGoldCardProvider';
export const GOLD_CARD_HEADER = 'Gold Card Provider';
export const GOLD_CARD_AUTH_TYPE_HEADER = 'Gold Card Auth Type';
export const GOLD_CARD_AUTH_TYPE_FIELD = 'goldCardAuthType';